import { useState } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "../hooks/useApi";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await publicApi.post("/auth/password/forgot", { email });
    } finally {
      setBusy(false);
      setSent(true);
    }
  }

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center px-4 py-12" data-testid="forgot-password-page">
      <div className="text-center mb-8">
        <p className="font-display text-xl tracking-[0.2em] uppercase text-white">Endure Beyond</p>
        <p className="text-white/50 text-sm mt-2">Reset your password</p>
      </div>
      {sent ? (
        <p className="text-sm text-white/60 max-w-sm text-center" data-testid="forgot-password-sent-message">
          If that email is registered, we've sent password reset instructions. Check your inbox.
        </p>
      ) : (
        <form onSubmit={submit} className="w-full max-w-sm space-y-4">
          <input
            type="email" required placeholder="Email" aria-label="Email address" value={email}
            onChange={(e) => setEmail(e.target.value)} data-testid="forgot-password-email-input"
            className="w-full bg-surface border border-border px-4 py-3 text-sm"
          />
          <button
            type="submit" disabled={busy} data-testid="forgot-password-submit-button"
            className="w-full bg-foreground text-background px-5 py-3 text-sm uppercase tracking-wide disabled:opacity-50"
          >
            {busy ? "Sending…" : "Send Reset Link"}
          </button>
        </form>
      )}
      <Link to="/sign-in" data-testid="forgot-password-back-link" className="text-xs text-white/50 underline mt-6">Back to sign in</Link>
    </div>
  );
}
